import { Navigate } from 'react-router-dom';

/**
 * The route preamble the back-office tree needs (P7, plan §6). The old single-tree
 * `guards.jsx` also held `FOHLoading` and closed over a build-time `LOGIN_PATH`; the FOH half
 * lives in `@verlo/node-ui` now, and here `LOGIN_PATH` is the password login (`/login`), which
 * `server_cloud.py` mounts and `server_node.py` does not.
 *
 * Tailwind scans source for whole class names, so the tone is written out, not interpolated.
 */

const LOGIN_PATH = '/login';

export const BackOfficeLoading = () => (
  <div className="min-h-screen flex items-center justify-center bg-surface-2">
    <div className="animate-pulse text-ink-soft">Loading...</div>
  </div>
);

/** Fallback for a lazily-loaded page, rendered inside a layout that is already up. */
export const PageLoading = () => (
  <div className="flex items-center justify-center py-24">
    <div className="animate-pulse text-ink-soft">Loading...</div>
  </div>
);

/**
 * The "still checking / not signed in" preamble. Returns an element to render instead of the
 * page, or `null` to carry on.
 */
export const authGate = ({ user, loading }, Spinner) => {
  if (loading) return <Spinner />;
  if (!user) return <Navigate to={LOGIN_PATH} replace />;
  return null;
};
